import {LocalizationConstants} from "./Constants/LocalizationConstants";
// import {ILanguageMenuViewOptions} from "./Views/Intro/LanguageMenuView";
import Storage from './Storage/Storage'
declare var require;

export interface IUpdateLocale{
    updateLocale();
}

export class LocalizationContents extends LocalizationConstants {
    public static ___current = LocalizationContents.getUserLanguage();
    public static ___content: {
        [key: string]: {
            "ru": string,
            "en": string,
            "kr": string,

        }
    } = require("../kyykka_Localization.json");

    public static setLanguage(lang:string){
        LocalizationContents.___current = lang;
    }

    public static getLanguage(){
        return LocalizationContents.___current;
    }

    public static getUserLanguage(): string{
        return navigator.language.slice(0,2);
    }
}


LocalizationConstants.getText = (key) => {
    return LocalizationContents.___content[key]?.[LocalizationContents.___current].replace(/\\n/g, "\n") || "ERROR!";
};
